import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  createCompanyUser,
  updateCompanyUser,
} from "../service/userManagement";
import { toast } from "react-toastify";
import eye from "../assets/image/eye.png";
import eye_of from "../assets/image/eye_off.png";
import { currentUser } from "../helpers";
import { useDispatch } from "react-redux";
import { setCompanyId } from "../redux/feature/jobSlice";

import { Col, Form, Modal } from "react-bootstrap";
import logo from "../assets/image/logo.png";
import { useForm, FormProvider } from "react-hook-form";
import MetaPixel from "../components/MetaPixel";
import { Box, Button } from "@mui/material";
import {
  GetCustomSettingTemplate,
  UpdateMultiStepper,
} from "../service/authApi";

export default function AddUser() {
  const methods = useForm();
  const [formVisible, setFormVisible] = useState(false);
  const handleNext = () => {
    setFormVisible(true);
    setTimeout(() => {
      window.location.href = "/Dashboard";
    }, 1000);
  };
  const userInfo = currentUser();
  const userRole = userInfo?.userRole;
  // eslint-disable-next-line no-unused-vars

  // eslint-disable-next-line no-unused-vars
  const { id } = useParams();
  const adMinIDData = userInfo?.userId;
  const ParentID = userInfo?.createdBy;
  // eslint-disable-next-line no-unused-vars
  const { state } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCompanyId(state));
    console.log(state, "state check");
    localStorage.setItem("admin_id", state?.adminID);
    localStorage.setItem("companyName", state?.companyName);
  }, []);

  const navigate = useNavigate();
  const companyNameByUser = state?.companyName;
  localStorage.setItem(state?.companyName, "CompanyNameForSuperAdmin");
  const companyNameForAdmin = userInfo?.companyName;
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);

  const initialValues = {
    id: null,
    firstName: "",
    lastName: "",
    mobile: "",
    companyName:
      userRole === "CompanyAdmin" || userRole === "CompanyManager"
        ? companyNameForAdmin
        : companyNameByUser,
    email: "",
    password: "",
    companyAdminId:
      userRole === "CompanyAdmin"
        ? adMinIDData
        : userRole === "CompanyManager"
        ? ParentID
        : state?.adminID,
  };

  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState(initialValues);
  const [show, setShow] = useState(false);
  const [modalContent, setModalContent] = useState({
    thankYouAddUser: "",
    thankyouForJobNote: " ",
  });
  const [error, setError] = useState(null);
  const handleClose = () => {
    setShow(false);
    setFormValues(initialValues);
    setErrors({});
  };
  const handleShow = () => setShow(true);
  const [showPassword, setShowPassword] = useState(false);

  const { firstName, lastName, mobile, companyName, email, password } =
    formValues;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
    }
  };
  const validateForm = () => {
    const newErrors = {};
    if (!firstName) {
      newErrors.firstName = "Enter your First name";
    }
    if (!lastName) {
      newErrors.lastName = "Enter your Last name";
    }

    if (!mobile) {
      newErrors.mobile = "Enter your phone number";
    }
    if (!companyName) {
      newErrors.companyName = "Enter Company Name";
    }
    if (!email) {
      newErrors.email = "Enter your email";
    }
    if (!formValues.id) {
      if (!password) {
        newErrors.password = "Enter your Password";
      } else if (password.length < 8) {
        newErrors.password = "Password must be at least 8 characters";
      } else if (!/\d/.test(password)) {
        newErrors.password = "Password must contain at least one digit";
      } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        newErrors.password =
          "Password must contain at least one special character";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(validateForm);
    const isValid = validateForm();

    if (isValid) {
      setLoader(true);
      try {
        let response = null;
        const obj = {
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          mobile: formValues.mobile,
          companyName: formValues.companyName,
          email: formValues.email,

          companyAdminId:
            userRole === "CompanyAdmin"
              ? adMinIDData
              : userRole === "CompanyManager"
              ? ParentID
              : state?.adminID,
          companyAdminId:
            userRole === "CompanyAdmin" || userRole === "CompanyManager"
              ? adMinIDData || ParentID
              : state?.adminID,
        };
        if (formValues.password) {
          obj.password = formValues.password;
        }
        if (formValues.address1) obj.address1 = formValues.address1;
        if (formValues.address2) obj.address2 = formValues.address2;
        if (formValues.province) obj.province = formValues.province;
        if (formValues.city) obj.city = formValues.city;
        if (formValues.postalCode) obj.postalCode = formValues.postalCode;
        if (formValues.country) obj.country = formValues.country;
        if (formValues.id) {
          obj.id = formValues.id;
          response = await updateCompanyUser(obj);
          toast.success(
            response?.message || "Company User updated successfully!",
            {
              autoClose: 3000,
            }
          );
        } else {
          response = await createCompanyUser(obj);

          if (!response?.status) {
            toast.error(response?.response?.data?.message);
          } else {
            toast.success("Company User added successfully!");
            await fetchData();
            setFormVisible(true);
          }
        }
        if (response) {
          try {
            const response = await UpdateMultiStepper(
              userInfo?.userId,
              "addUser"
            );
          } catch (error) {
            console.log(error);
          }
        }
        if (response) {
          setData((prevData) => {
            const dataArray = Array.isArray(prevData) ? prevData : [];
            return [response?.data, ...dataArray];
          });
          // await getTableData();
          setFormValues(initialValues);
          handleClose();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        setTimeout(() => {
          setLoader(false);
        }, 3000);
      }
    }
  };
  const fetchData = async () => {
    try {
      setLoader(true);
      const data = await GetCustomSettingTemplate();

      if (data.status) {
        // Assuming the API returns an object with body content
        setModalContent({
          thankYouAddUser:
            data.data.thankYouAddUser ||
            "Default body content if API fails to provide.",
          thankyouForJobNote: data.data.thankyouForJobNote,
        });
      } else {
        setError(data.data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching data");
    } finally {
      setLoader(false);
    }
  };
  return (
    <>
      <MetaPixel />
      <div className="container-fluid bg-white custom-parent">
        <div className="row custom-row bg-white vh-100">
          {/* <div className="col-lg-6 ">
              <SampleSlider />
            </div> */}
          <div className="col-lg-12">
            <div className="formcollectionContainer">
              <div className="logo formlogo">
                <img src={logo} alt="" className="s" />
              </div>
              <div className="form_text">
                <div className="container d-flex flex-column ">
                  <div className="JobformHead">
                    <div className="heading d-flex align-item-center">
                      <h1 className="main-heading jobCreate">
                        Create new user
                      </h1>
                    </div>
                    <p className="sub-heading mb-4">
                      {" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "16px",
                        }}
                      >
                        <b>*</b>{" "}
                      </span>
                      This is for mobile user login, you cannot use the same
                      email as the original login email.
                    </p>
                  </div>
                  <div className="stepperform mb-5">
                    <form
                      className="d-flex flex-column py-3 gap-3"
                      onSubmit={handleSubmit}
                    >
                      <div className=" mb-4 position-relative">
                        <Row>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label className="CreateUserLabel">
                                First Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="firstName"
                                value={firstName}
                                onChange={handleChange}
                                className={`px-3 ${
                                  errors.firstName ? "border-danger mb-0" : ""
                                }`}
                                placeholder="Enter first name"
                              />
                            </Form.Group>
                            {errors.firstName && (
                              <Form.Text className=" text-danger">
                                Enter your First name
                              </Form.Text>
                            )}
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label className="CreateUserLabel">
                                {" "}
                                Last Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="lastName"
                                value={lastName}
                                onChange={handleChange}
                                className={`px-3 ${
                                  errors.lastName ? "border-danger mb-0" : ""
                                }`}
                                placeholder="Enter Last name"
                              />
                            </Form.Group>
                            {errors.lastName && (
                              <Form.Text className=" text-danger">
                                Enter your Last name
                              </Form.Text>
                            )}
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label className="CreateUserLabel">
                                Mobile
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="mobile"
                                value={mobile}
                                onChange={handleChange}
                                className={`px-3 ${
                                  errors.mobile ? "border-danger mb-0" : ""
                                }`}
                                placeholder="+1 (251) 420-9612"
                                onKeyPress={(e) => {
                                  if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors.mobile && (
                                <Form.Text className="text-danger">
                                  {errors.mobile === "Enter your number"
                                    ? "Enter your number"
                                    : "Phone number must be exactly 10 digits"}
                                </Form.Text>
                              )}
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label className="CreateUserLabel">
                                Company Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="companyName"
                                value={companyName}
                                onChange={handleChange}
                                className={`px-3 ${
                                  errors.companyName ? "border-danger mb-0" : ""
                                }`}
                                placeholder="Enter Company name"
                                onKeyPress={(e) => {
                                  if (!/^\d$/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                disabled
                                // disabled={formValues.id ? true : false}
                              />
                              {errors.companyName && (
                                <Form.Text className="text-danger">
                                  Enter Company name
                                </Form.Text>
                              )}
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group>
                              <Form.Label className="CreateUserLabel">
                                Email
                              </Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                value={email}
                                onChange={handleChange}
                                className={`px-3 ${
                                  errors.email ? "border-danger mb-0" : ""
                                }`}
                                placeholder="Enter Your Email"
                              />
                              {errors.email && (
                                <Form.Text className="text-danger">
                                  Enter your email
                                </Form.Text>
                              )}{" "}
                              <br />
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "16px",
                                }}
                              >
                                <b>NOTE:</b> User Email cannot be same as
                                orignal login{" "}
                              </span>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group>
                              <Form.Label className="CreateUserLabel">
                                Password {formValues.id ? "(optional)" : ""}
                              </Form.Label>
                              <div className="position-relative">
                                <Form.Control
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  value={password}
                                  onChange={handleChange}
                                  className={`px-3 pe-5 ${
                                    errors.password ? "border-danger mb-0" : ""
                                  }`}
                                  placeholder="Enter a Password"
                                />
                                <img
                                  src={showPassword ? eye : eye_of}
                                  alt="Toggle Password Visibility"
                                  className="position-absolute right_icon"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => setShowPassword(!showPassword)}
                                />
                              </div>
                              {errors.password && (
                                <Form.Text className="text-danger">
                                  {errors.password}
                                </Form.Text>
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <Box
                          className="rounded-4 p-3 "
                          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                        >
                          <Box sx={{ flex: "1 1 auto" }} />
                          <Button
                            className="multiStepperButton"
                            type="submit"
                            variant="contained"
                          >
                            Submit
                          </Button>
                        </Box>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {loader ? (
            <ReactLoading
              type={"bars"}
              color="#33995e"
              height={60}
              width={60}
              className={"globe_loader"}
            />
          ) : (
            ""
          )} */}
      </div>
      <Modal show={formVisible} centered className="custom-modal ">
        <Modal.Header>
          <div className="modal-title-container">
            <Modal.Title className="thankyou">
              Thank You For Submitting!
            </Modal.Title>
          </div>
        </Modal.Header>
        <div className="modal-body-container ">
          <Modal.Body>
            {loader ? (
              <div>Loading content...</div>
            ) : error ? (
              <div className="text-danger">{error}</div>
            ) : (
              <div>
                {(
                  <div
                    dangerouslySetInnerHTML={{
                      __html: modalContent.thankYouAddUser,
                    }}
                  ></div>
                ) || (
                  <>
                    Thank you for submitting your overhead. The job
                    configuration tab has been set up successfully. Please
                    ensure you review and edit the numbers to make them as
                    accurate as possible for your company. If your bookkeeping
                    isn't up to date, we've used industry standard numbers based
                    on your answers, so feel free to adjust them to better
                    reflect your actual expenses.
                    <br />
                    <br /> We have just one more question to complete the setup.
                    This step will establish your mobile app login and allow you
                    to access the price book on your computer as well (please
                    note you need to use a different email than your current
                    one). You can add more users and edit their permissions
                    later in the user management section.
                    <br />
                    <br /> After completing this process, please visit the
                    learning center to watch the short videos that will guide
                    you on how to use our platform effectively. These resources
                    will help you maximize the benefits of the program. If you
                    have any questions along the way, don’t hesitate to ask!
                  </>
                )}
              </div>
            )}
          </Modal.Body>
        </div>
        <Modal.Footer>
          <div
            style={{
              flexGrow: 1,
              alignSelf: "center",
              color: "red",
              fontSize: "16px",
            }}
          >
            {(
              <div
                dangerouslySetInnerHTML={{
                  __html: modalContent.thankyouForJobNote,
                }}
              ></div>
            ) || (
              <>
                <b>Note:</b> Please take a moment to carefully review the above
                details
              </>
            )}
          </div>
          <Button
            variant=" "
            className="AddUser multiStepperButton Btn"
            onClick={handleNext}
          >
            Go to Dashboard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
